import { withNamespace } from "@/i18n/lazy-route"

/** Every account's phones, messages and webhooks (LLD §9.17, Task 6.6), with the `adminGateway` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminGateway.json"),
  fr: () => import("@/i18n/locales/fr/adminGateway.json"),
}

export const AllDevicesScreen = withNamespace(
  "adminGateway",
  () => import("./screens/AllDevicesScreen"),
  translations,
)
export const AllMessagesScreen = withNamespace(
  "adminGateway",
  () => import("./screens/AllMessagesScreen"),
  translations,
)
export const AllWebhooksScreen = withNamespace(
  "adminGateway",
  () => import("./screens/AllWebhooksScreen"),
  translations,
)
